// angular
//   .module("HeroPRO")
//   .directive("actionItems", ActionItemsDirective);


export default function ActionItemsDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/actionItems/actionItemsTemplate.html',
        controller: 'actionItemsController',
        controllerAs: 'actionItems',
        bindToController: true,
        scope: {
            source: '@source', // string
            showFilters: '=showFilters', // true/false
            showRefreshButton: '=showRefreshButton', // true/false
            showSeeAll: '=showSeeAll', // true/false
            showCompletedToday: '=showCompletedToday', // true/false
            maxActionItems: '=maxActionItems', // integer
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/actionItems/actionItemsDirective.js